import { render, staticRenderFns } from "./add-acount.vue?vue&type=template&id=3e9e3e4c&"
import script from "./add-acount.vue?vue&type=script&lang=js&"
export * from "./add-acount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports